import { useTranslation } from 'react-i18next'

import * as styles from './TableModalCounter.module.css'

function TableModalCounter({ count = 0, text }) {
  const { t } = useTranslation()

  return <span className={styles.counter}>{t(text, { count })}</span>
}

export default TableModalCounter
